import { Opportunity, Skill } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { OpportunitySkillEntityConfig } from "./config";
import { OpportunitySkillFilters } from "./filters";
import { OpportunitySkillMethods } from "./methods";

@HyperEntity("opportunity-skill", OpportunitySkillEntityConfig)
export class OpportunitySkill extends extender(
  OpportunitySkillFilters,
  OpportunitySkillMethods,
) {
  @Fields.string({ dbName: "skill_id" })
  skillId = "";

  @Fields.string({ dbName: "opportunity_id" })
  opportunityId = "";

  @Relations.toOne(() => Skill, "skillId")
  skill?: Skill;

  @Relations.toOne(() => Opportunity, "opportunityId")
  opportunity?: Opportunity;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
